import Intro from '/intro/Intro.jsx'
import Sphere from '/intro/introAssets/sphere/Sphere.jsx'

export default function HomeScreen() {

    return (
        <>
            <Intro/>
            <Sphere/>
        </>
    )
}